import { Object3D } from "three";
import { EHandlePosition, EOrientation, HorizontalSide, VerticalSide } from "../Metadata/FrontHandleMetadata";

export class HandleBoneObject extends Object3D {

    public isReversed: boolean = false;
    public isHorizontal: boolean = false;
    
    public horizontalAlign: HorizontalSide = HorizontalSide.Center;
    public verticalAlign: VerticalSide = VerticalSide.Center;
    public orientation: EOrientation = EOrientation.Normal;
    public handlePosition: EHandlePosition = EHandlePosition.DefaultCenter;
    handleBone: any;

    constructor() {
        super();   
    }
}